import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovVariableProps,
    LoadMarkovVariableById,
    setMarkovVariableEdit,
    setMarkovVariableReloadEdit,
    initMarkovVariable,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    variableId = null,
}: MarkovVariableProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)
    const datasetSelected = useSelector((state: StoreType) => state.markovDataset.datasetSelected)

    const variable = useSelector((state: StoreType) => state.markovVariable.variableEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovVariable.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovVariableReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovVariableReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (variableId === 0) {
            dispatch(setMarkovVariableEdit(initMarkovVariable))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovVariableById(variableId, model.id, datasetSelected.id).then((res) => {
                dispatch(setMarkovVariableEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!variable) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{variable.id ? `${lang.editVariable} # ${variable.id}` : lang.addVariable}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form variable={variable} />
                }
                {
                    reloadEdit
                    && <Form variable={variable} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
